import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X as CloseIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { useTheme } from './ThemeProvider';
export function Navbar() {
  const [open, setOpen] = useState(false);
  const {
    theme
  } = useTheme();
  const close = () => setOpen(false);
  const darkLogo = 'https://cdn.magicpatterns.com/uploads/4dE9fLpUrJZPexP4Wa8YZa/Layer_1.svg';
  // Full-color Yetu logo used on the light theme.
  const lightLogo = 'https://cdn.magicpatterns.com/uploads/vp8wHRm6LNapEACMvi3gx4/yetu_full_color_logo.svg';
  return <header className="nav" data-id="element-146">
      <div className="wrap nav__in" data-id="element-147">
        <Link to="/" className="logo" onClick={close} data-id="element-148">
          <img src={theme === 'light' ? lightLogo : darkLogo} alt="Yetu Design Lab" className="h-10 object-contain transition-opacity duration-300" data-id="element-149" />
        </Link>
        <div className="navlinks hidden md:flex" data-id="element-150">
          <Link to="/#work" data-id="element-151">Work</Link>
          <Link to="/#studio" data-id="element-152">Studio</Link>
          <Link to="/blog" data-id="element-153">Blog</Link>
          <Link to="/#contact" data-id="element-154">Contact</Link>
        </div>
        <div className="nav__cta" data-id="element-155">
          <div className="hidden md:block" data-id="element-156">
            <CtaButton to="/#contact" variant="pill" data-id="element-157">
              Book Free Consultation
            </CtaButton>
          </div>
          <button className="burger md:hidden" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} aria-controls="mobile-menu" data-id="element-158">
            {open ? <CloseIcon size={24} className="mx-auto" data-id="element-159" /> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mx-auto" data-id="element-160">
                <line x1="3" y1="12" x2="21" y2="12" data-id="element-161"></line>
                <line x1="3" y1="6" x2="21" y2="6" data-id="element-162"></line>
                <line x1="3" y1="18" x2="21" y2="18" data-id="element-163"></line>
              </svg>}
          </button>
        </div>
      </div>

      {open && <nav id="mobile-menu" className="md:hidden wrap flex flex-col gap-1 pb-5 border-t border-line pt-3" data-id="element-164">
          <Link to="/#work" onClick={close} className="py-3 text-lg font-medium text-ink hover:text-lime transition-colors" data-id="element-165">
            Work
          </Link>
          <Link to="/#studio" onClick={close} className="py-3 text-lg font-medium text-ink hover:text-lime transition-colors" data-id="element-166">
            Studio
          </Link>
          <Link to="/blog" onClick={close} className="py-3 text-lg font-medium text-ink hover:text-lime transition-colors" data-id="element-167">
            Blog
          </Link>
          <Link to="/#contact" onClick={close} className="py-3 text-lg font-medium text-ink hover:text-lime transition-colors" data-id="element-168">
            Contact
          </Link>
          <div className="mt-2 self-start" data-id="element-169">
            <CtaButton to="/#contact" variant="pill" onClick={close} data-id="element-170">
              Book Free Consultation
            </CtaButton>
          </div>
        </nav>}
    </header>;
}